import GoogleMap from 'google-map-react';
import React from 'react';
import { array, number, object } from 'prop-types';
import styles from './Maps.scss';
import { defaultStyles } from './mapStyles.js';

const GOOGLE_CLIENT_ID = 'gme-wixcomltd2';
let directions;
let directionsDisplay;

const Marker = props => {
  const { lng, lat, icon } = props;
  return (
    <div lng={lng} lat={lat}>
      {icon}
    </div>
  );
};

export class GMapReact extends React.Component {
  state = {
    center: this.props.center || this.props.origin,
    zoom: this.props.zoom,
    externalMapChanged: false,
    map: undefined,
    showMap: true,
  };

  onGoogleApiLoaded = ({ map, maps }) => {
    this.setState({ map });
    initMapServices(map, maps);
    this.getDirections();
  };

  getDirections = async () => {
    const { origin, destination } = this.props;
    if (!origin || !destination || !directions) {
      //todo masha ggogle services for testing mocks?

      return;
    }

    const req = {
      origin,
      destination,
      travelMode: 'DRIVING',
    };

    this.setState({ showMap: false });
    directions.route(req, (res, status) => {
      if (status === 'OK') {
        directionsDisplay.setDirections(res);
      } else {
        // todo masha throw error?
      }
    });
  };

  shouldCalculateDirections = prevProps => {
    return (
      (this.props.origin && this.props.destination && prevProps.origin !== this.props.origin) ||
      this.props.destination !== prevProps.destination
    );
  };

  zoomOutUntilEastMarkIsVisible = eastMarker => {
    let eastBound = this.state.map.getBounds().ga.l;
    let zoom = this.state.map.getZoom();
    while (eastBound < eastMarker) {
      zoom = this.state.map.getZoom();
      this.state.map.setZoom(zoom - 1);
      eastBound = this.state.map.getBounds().ga.l;
    }
    setTimeout(() => this.setState({ showMap: true }), 200);
  };

  componentDidUpdate(prevProps) {
    if (this.shouldCalculateDirections(prevProps)) {
      this.getDirections();
    }
  }

  shiftCenterToVisibleArea = (westMarker, center, zoom) => {
    const newCenterLng = westMarker - 70 / Math.pow(2, zoom);
    const newCenter = { lat: center.lat, lng: newCenterLng };
    this.setState({ center: newCenter });
  };

  onMapChange = data => {
    if (!this.state.map) {
      return;
    }

    const { center, zoom: newZoom } = data;
    const { origin, destination } = this.props;
    const eastMarker = origin.lng > destination.lng ? origin.lng : destination.lng;

    if (this.state.center.lat !== center.lat || this.state.center.lng !== center.lng) {
      const westMarker = origin.lng < destination.lng ? origin.lng : destination.lng;
      this.shiftCenterToVisibleArea(westMarker, center, newZoom);
    }
    this.zoomOutUntilEastMarkIsVisible(eastMarker);

    /** if we call outside services that change the map ---> Directions , we need to keep the state consistent **/
  };

  render() {
    const { zoom, center } = this.state;
    const { markups } = this.props;
    const allMarks = markups.map((markup, index) => (
      <Marker icon={markup.icon} key={index} lng={markup.latLng.lng} lat={markup.latLng.lat} />
    ));
    const style = this.state.showMap ? {} : { filter: 'blur(60px)' };
    const opacity = this.state.showMap ? '0' : '0';
    return (
      <div className={styles.container} style={style}>
        {/*<div className={styles.overlay} style={{ opacity }} />*/}
        <GoogleMap
          onGoogleApiLoaded={this.onGoogleApiLoaded}
          bootstrapURLKeys={{ client: GOOGLE_CLIENT_ID }}
          onChange={this.onMapChange}
          center={center}
          yesIWantToUseGoogleMapApiInternals
          options={getMapStyleOptions}
          zoom={zoom}
        >
          {allMarks}
        </GoogleMap>
      </div>
    );
  }
}

const getMapStyleOptions = () => {
  return {
    disableDefaultUI: true,
    gestureHandling: 'none',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    animatedZoom: false,
    clickableIcons: false,
    draggableCursor: 'default',
    draggable: false,
    styles: defaultStyles,
  };
};

const getDirectionsDisplayOptions = () => {
  return {
    suppressMarkers: true,
    draggable: false,
    polylineOptions: {
      clickable: false,
      strokeColor: '#4eb7f5',
    },
  };
};

const initMapServices = (map, maps) => {
  directions = new maps.DirectionsService();
  directionsDisplay = new maps.DirectionsRenderer(getDirectionsDisplayOptions());
  directionsDisplay.setMap(map);
};

GMapReact.propTypes = {
  center: object,
  zoom: number,
  origin: object,
  destination: object,
  markups: array,
};
